import React, { useState, useEffect } from "react";
import "../css/BaseChat.css";
import ChatMobile from "./chatmobile";
import ChatDesktop from "./chatdesktop";

const BaseChat = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check the initial screen orientation
    const checkOrientation = () => {
      setIsMobile(window.matchMedia("(orientation: portrait)").matches);
    };

    // Add event listener for screen orientation changes
    window.addEventListener("resize", checkOrientation);

    // Run the initial check
    checkOrientation();

    // Clean up event listener
    return () => window.removeEventListener("resize", checkOrientation);
  }, []);

  return (
    <div>
      <div className="glow-background"></div>
      <div className="content">
        {isMobile ? <ChatMobile /> : <ChatDesktop />}
      </div>
    </div>
  );
};

export default BaseChat;
